import { render } from "./ClassroomsModule.vue?vue&type=template&id=5f70ec92&scoped=true"
import script from "./ClassroomsModule.vue?vue&type=script&lang=js"
export * from "./ClassroomsModule.vue?vue&type=script&lang=js"

import "./ClassroomsModule.vue?vue&type=style&index=0&id=5f70ec92&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f70ec92"

export default script